<template>
  <!-- 轮播图-->
  <div class="picMarquee-left">
    <div class="hd">
      <h3 class="panel-title l"><span class="glyphicon glyphicon-camera" aria-hidden="true"></span> 魅力校园</h3>
      <a class="next" @click="next"></a>
      <a class="prev" @click="prev"></a>
    </div>
    <div class="bd">
      <ul class="picList">
        <li v-for="(img,index) in imgs" :key="index">
          <div class="pic">
            <a href="javascript:;" target="_blank">
              <p v-html="img.arts[0].des" v-if='img.arts'  @click="jumpToAr(img)"></p>
            </a>
          </div>
        </li>
      </ul>
    </div>
    <!-- 提示框 -->
      <tip :tip="tip" v-show="tipShow"></tip>
      <!-- 预加载 -->
    <page-load v-if="loading"></page-load>
  </div>
</template>

<script>
import { getArtCates, getArticles } from "../api/api";
import pageLoad from "../pageload/pageload";
export default {
  components: { pageLoad },
  data() {
    return {
      animate: false,
      imgs: [], //图片集合
      tip: "", //提示语
      tipShow: false, //提示框默认状态
      loading: true //预加载
    };
  },
  created() {
    this._getArtCates(); //获取信息栏目数据
  },
  methods: {
    //获取信息栏目数据
    _getArtCates() {
      let lunbo = JSON.parse(sessionStorage.getItem("lunbo"));
      this.loading = true;
      if (lunbo == null) {
        let module = {
          sch_id: 1,
          topic_id: 2
        };
        getArtCates(module)
          .then(res => {
            if (res.status && res.data && res.data.length > 0) {
              sessionStorage.setItem("lunbo", JSON.stringify(res));
              for (let i = 0; i < res.data.length; i++) {
                if (res.data[i].visible == 2 && res.data[i].odx > 10) {
                  this.imgs.push(res.data[i]);
                  this._getArticles(res.data[i].id, res.data[i]);
                }
              }
            } else {
              this.loading = false;
              this.tipCtr("暂无数据");
            }
          })
          .catch(err => {
            this.loading = false;
            this.tipCtr("未找到相关数据,请重新加载");
          });
      } else {
        for (let i = 0; i < lunbo.data.length; i++) {
          if (lunbo.data[i].visible == 2 && lunbo.data[i].odx > 10) {
            this.imgs.push(lunbo.data[i]);
            this._getArticles(lunbo.data[i].id, lunbo.data[i]);
          }
        }
      }
    },
    //获取文章列表
    _getArticles(id, arr) {
      let module = {
        sch_id: 1,
        cate_id: id
      };
      getArticles(module)
        .then(res => {
          this.loading = false;
          if (res.status && res.data && res.data.arts.length > 0) {
            this.$set(arr, "arts", res.data.arts);
          } else {
            this.tipCtr("暂无数据");
          }
        })
        .catch(err => {
          this.loading = false;
          this.tipCtr("未找到相关数据,请重新加载");
        });
    },
    //提示框函数
    tipCtr(text) {
      this.tip = text;
      this.tipShow = true;
      setTimeout(() => {
        this.tipShow = false;
      }, 1200);
    },
    //跳转到校园风景详情
    jumpToAr(item) {
      this.$router.push({ path: "article/" + item.id + "/" + item.arts[0].id });
    },
    next() {
      this.add();
    },
    prev() {
      this.minus();
    },
    add() {
      this.imgs.push(this.imgs[0]); // 将数组的第一个元素添加到数组的最后
      this.imgs.shift(); //删除数组的第一个元素
    },
    minus() {
      this.imgs.unshift(this.imgs[this.imgs.length - 1]); //讲数组的最后一项添加到数组的第一项
      this.imgs.pop(); //删除最后一项
    }
  }
};
</script>
<style scoped>
/*魅力校园 轮播图*/
.picMarquee-left {
  width: 100%;
  overflow: hidden;
  position: relative;
  padding: 0 20px;
}

.picMarquee-left .hd {
  overflow: hidden;
  height: 40px;
  background: #f4f4f4;
  padding: 0 20px;
}

.picMarquee-left .hd h3 {
  line-height: 40px;
  font-weight: bold;
  color: #428bca;
}

.picMarquee-left .hd h3 span {
  margin-right: 5px;
}

.picMarquee-left .hd .prev,
.picMarquee-left .hd .next {
  display: block;
  width: 5px;
  height: 9px;
  float: right;
  margin-right: 5px;
  margin-left: 10px;
  margin-top: 15px;
  overflow: hidden;
  cursor: pointer;
  background: url("../assets/imgs/arrow.png") no-repeat;
}

.picMarquee-left .hd .next {
  background-position: 0 -50px;
}

.picMarquee-left .hd .prevStop {
  background-position: -60px 0;
}

.picMarquee-left .hd .nextStop {
  background-position: -60px -50px;
}

.picMarquee-left .bd {
  padding: 10px;
  overflow: hidden;
}

.picMarquee-left .bd ul {
  width: 1200px;
  height: 120px;
  overflow: hidden;
  zoom: 1;
  padding-left: 0;
}

.picMarquee-left .bd ul li {
  width: 17%;
  margin: 0 1%;
  float: left;
  _display: inline;
  overflow: hidden;
  text-align: center;
}

.picMarquee-left .bd ul li .pic {
  text-align: center;
}

.picMarquee-left .bd ul li .pic >>> img {
  width: 100%;
  height: 120px;
  display: block;
  padding: 2px;
  border: 1px solid #ccc;
}

.picMarquee-left .bd ul li .pic a:hover img {
  border-color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/carouselComp.vue